import http from '../_http'

const authLog = {
  //user
  summaryUser: (m) => { return http.get(`manager/log/auth/user`, m); },
  listUser: (m) => { return http.post(`manager/log/auth/user/list`, m); },
  detailUser: (m) => { return http.get(`manager/log/auth/user/${m.id}`, m); },

  //admin
  summaryAdmin: (m) => { return http.get(`manager/log/auth/admin`, m); },
  listAdmin: (m) => { return http.post(`manager/log/auth/admin/list`, m); },
  detailAdmin: (m) => { return http.get(`manager/log/auth/admin/${m.id}`, m); },

  //partner
  summaryPartner: (m) => { return http.get(`manager/log/auth/partner`, m); },
  listPartner: (m) => { return http.post(`manager/log/auth/partner/list`, m); },
  detailPartner: (m) => { return http.get(`manager/log/auth/partner/${m.id}`, m); },
}

export default authLog

export { authLog }